/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationPatchRequestSchema = z.object({
  countryCode: z.string().nullish(),
  holidaySchemeId: z.int().nullish(),
  subdivisionCode: z.string().nullish(),
  workloadSchemeId: z.int().nullish(),
});
